export const getDownloadErrorMessage = (error: any) => {
  const message = error?.response?.data?.message || (error instanceof Error ? error.message : '');
  if (!message) return '';

  try {
    const parsed = JSON.parse(message);
    return parsed?.message || message;
  } catch {
    return message;
  }
};

export const triggerDownload = (url: string, delay = 0) => {
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);

  setTimeout(() => {
    link.click();
    link.remove();
  }, delay);
};
